export const KPICard = ({ label, value, sub, accent = "default", testId, icon: Icon, onClick }) => {
  const accentMap = {
    default: "text-[#09090B]",
    success: "text-[#10B981]",
    warning: "text-[#F59E0B]",
    error: "text-[#F43F5E]",
    info: "text-[#3B82F6]",
  };

  return (
    <div
      data-testid={testId}
      onClick={onClick}
      className={`bg-white border border-[#E4E4E7] rounded-md p-5 hover:border-[#09090B] transition-colors ${onClick ? "cursor-pointer" : ""}`}
    >
      <div className="flex items-start justify-between">
        <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#52525B]">
          {label}
        </div>
        {Icon && <Icon size={16} className="text-[#52525B]" strokeWidth={1.75} />}
      </div>
      <div className={`mt-3 font-heading text-3xl font-bold tracking-tight font-mono-data ${accentMap[accent]}`}>
        {value}
      </div>
      {sub && <div className="text-xs text-[#52525B] mt-1.5">{sub}</div>}
    </div>
  );
};

export default KPICard;
